import React from 'react';
import './style.css';

const ErrorMessage = ({ message = "Something went wrong! Please try again later." }) => {
	return (
		<div className='error-message-containers'>
			<p className="error-message-text">⚠️ Error: {message}</p>
			<p className="error-message-suggestion">If the problem persists, please check your network connection.</p>
		</div>
	);
}

export default ErrorMessage;